import request from '@/utils/request';
const baseURL = '/api/posclient/';

//取得帳務資料
export function getRecord(data) {
  return request({
    method: 'post',
    url: `${baseURL}accounting/getRecord`,
    data,
  });
}

//執行交班
export function inputBaseInfo(data) {
  return request({
    timeout: 60000,
    method: 'post',
    url: `${baseURL}accounting/inputBaseInfo`,
    data,
  });
}
//完成交班
export function shiftDone(data) {
  return request({
    method: 'post',
    url: `${baseURL}accounting/done`,
    data,
  });
}

//列印報表
export function print(data) {
  return request({
    method: 'post',
    url: `${baseURL}accounting/print`,
    data,
  });
}
